import React from 'react';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center">
          {/* 左侧 - 公司视觉 */}
          <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pr-10">
            <div className="relative rounded-lg overflow-hidden shadow-xl">
              <img 
                src="./images/common/about-bg.webp"
                alt="办公环境" 
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/30 to-transparent"></div>
            </div>
          </div>
          
          {/* 右侧 - 关于文本 */}
          <div className="w-full md:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold text-dark mb-6">关于引力结构</h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              引力结构致力于开发简单易用、功能强大的AI应用，专注于创造直观体验，将复杂技术转化为智能解决方案，让科技真正走入生活的每个角落。
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              我们相信，技术的价值在于为人们创造便捷、高效的生活方式。通过不断创新和优化，我们的产品已经服务了超过1000万用户，帮助他们更轻松地解决日常问题。
            </p>
            
            {/* 数据展示 */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <span className="block text-3xl font-bold text-primary mb-2">1000万+</span>
                <span className="text-gray-500">活跃用户</span>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <span className="block text-3xl font-bold text-primary mb-2">4.8</span>
                <span className="text-gray-500">用户评分</span>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <span className="block text-3xl font-bold text-primary mb-2">12+</span>
                <span className="text-gray-500">AI产品</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 